import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { useEffect, useRef, useState } from 'react';
import { getIconList } from '../InputPower/config';
import EcoTabSectionLR from 'eco-design/sections/eco-tab-section-l-r';
import EcoImg from 'eco-design/base/eco-img';

const SectionIconList = () => {
    const { t } = useLang('theProduct.InputPower');
    const { locale } = getLocal();
    const listA = getIconList(locale, 'a');
    const listB = getIconList(locale, 'b');
    return (
        <div className="right-content">
            <p className="right-content-title">{t('InputPower_right_title1')}</p>
            <ul className="icon-list">
                {listA.map((item, index) => (
                    <li className="icon-item" key={index}>
                        {item.icon()}
                        <p>{item.name}</p>
                    </li>
                ))}
            </ul>
            <div className="right-content-desc">{t('InputPower_right_desc')}</div>
            <p className="right-content-title">{t('InputPower_right_title2')}</p>
            <ul className="icon-list">
                {listB.map((item, index) => (
                    <li className="icon-item" key={index}>
                        {item.icon()}
                        <p>{item.name}</p>
                    </li>
                ))}
            </ul>
            <p className="right-content-desc">{t('InputPower_right_tips')}</p>
        </div>
    );
};

const AcOutput: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('AcOutput');
    const swiperRef = useRef<any>(null);

    const [slidesPerView, setSlidesPerView] = useState<number | 'auto'>(1);
    const [loop, setLoop] = useState(true);
    const [swiperKey, setSwiperKey] = useState(0); // 用于强制重新渲染Swiper
    const getSlidesPerView = () => {
        if (window.innerWidth > 1024) {
            return 1;
        }
        return 'auto';
    };

    const getLoop = () => {
        if (window.innerWidth > 1024) {
            return true;
        }
        return false;
    };

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267952724/2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751267951754/2-pad.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267951368/3-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751267952476/3-pad.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267952015/4-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1751267951219/4-pad.jpg',
        },
    ];

    // 监听屏幕宽度变化 改变slierPerView
    useEffect(() => {
        const handleResize = () => {
            const newSlidesPerView = getSlidesPerView();
            const newLoop = getLoop();

            setSlidesPerView(newSlidesPerView);
            setLoop(newLoop);

            // 当loop参数发生变化时，强制重新渲染Swiper组件
            setSwiperKey((prev) => prev + 1);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // 当Swiper重新初始化后，设置初始slide位置
    useEffect(() => {
        if (swiperRef.current) {
            setTimeout(() => {
                if (swiperRef.current) {
                    // 重新初始化navigation
                    swiperRef.current.navigation.destroy();
                    swiperRef.current.navigation.init();
                    swiperRef.current.navigation.update();

                    // 设置初始slide位置
                    if (window.innerWidth > 1024 && loop) {
                        swiperRef.current.slideTo(1, 0); // loop模式下从第二个slide开始
                    } else {
                        swiperRef.current.slideTo(0, 0); // 非loop模式从第一个slide开始
                    }
                }
            }, 100);
        }
    }, [loop]);

    return (
        <div className={styles.AcOutput}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />

            <div className="ac-output-box page-layout">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    slidesPerView={slidesPerView}
                    spaceBetween={24}
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    loop={loop}
                    loopAdditionalSlides={loop ? 2 : 0}
                    loopedSlides={loop ? 4 : 0}
                    observer={true} // 监视DOM变化
                    observeParents={true} // 监视父元素变化
                >
                    {loop &&
                        [list[list.length - 1]].map((item, index) => (
                            <SwiperSlide key={index}>
                                <EcoImg pc={item.pc} pad={item.pad} className="ac-output-img" />
                            </SwiperSlide>
                        ))}
                    <SwiperSlide>
                        <EcoTabSectionLR
                            items={[
                                {
                                    desc: SectionIconList(),
                                    labelIsImg: true,
                                    pc: 'https://websiteoss.ecoflow.com/upload/image/1751267952266/1-pc.jpg',
                                    pad: 'https://websiteoss.ecoflow.com/upload/image/1751267951569/1-pad.jpg',
                                    h5: 'https://websiteoss.ecoflow.com/upload/image/1751267951569/1-pad.jpg',
                                    tabLabel: '1200W',
                                    tabValue: 'a',
                                },
                            ]}
                        />
                    </SwiperSlide>
                    {list.slice(0, list.length - 1).map((item, index) => (
                        <SwiperSlide key={index}>
                            <EcoImg pc={item.pc} pad={item.pad} className="ac-output-img" />
                        </SwiperSlide>
                    ))}

                    {!loop &&
                        [list[list.length - 1]].map((item, index) => (
                            <SwiperSlide key={index}>
                                <EcoImg pc={item.pc} pad={item.pad} className="ac-output-img" />
                            </SwiperSlide>
                        ))}

                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                </Swiper>
            </div>
        </div>
    );
};

export default AcOutput;
